import api from '@/api/index.js'

const profile = {
  state: {
    selectedReportOperator: null,
    selectedReportPeriod: null,
    selectedReportToDate: null
  },

  mutations: {
    SET_PROFILE_SELECTED_REPORT_OPERATOR: (state, operator) => {
      state.selectedReportOperator = operator;
    },
    SET_PROFILE_SELECTED_REPORT_PERIOD: (state, period) => {
      state.selectedReportPeriod = period;
    },
    SET_PROFILE_SELECTED_REPORT_TO_DATE: (state, input) => {
      state.selectedReportToDate = input;
    },
  },

  actions: {
    SetProfileSelectedReportOperator({commit}, operator) {
      commit('SET_PROFILE_SELECTED_REPORT_OPERATOR', operator);
    },
    SetProfileSelectedReportPeriod({commit}, period) {
      commit('SET_PROFILE_SELECTED_REPORT_PERIOD', period);
    },
    SetProfileSelectedReportToDate({commit}, toDate) {
      commit('SET_PROFILE_SELECTED_REPORT_TO_DATE', toDate);
    },
  }
}

export default profile
